import Helpers from '@helpers';
import * as React from 'react';
import OrderSummaryHelper from '../order-summary/order_summary';
import { Prop, ShippingItem, ShippingListHelper, State } from './model';
import './styles.css';

const shippingListHelper: ShippingListHelper = {};
class ShippingList extends React.Component<Prop, State> {
    constructor(props) {
        super(props);

        this.state = this.getInitialState();
    }

    public componentDidMount() {
        shippingListHelper.reloadList = this.reloadList;
        shippingListHelper.setOfficialInvoice = this.setOfficialInvoice;
        shippingListHelper.setInstallmentState = this.setInstallmentState;
    }

    public componentDidUpdate() {
        // If selected id is no longer in the list, clear it.
        if (this.state.selectedShippingId &&
            this.state.items &&
            !this.state.items.find(x => x.id === this.state.selectedShippingId)) {
            this.setState({
                selectedShippingId: null
            });
        }

        // turn off fragile if shipping type doesn't support fragile
        if (this.state.isFragile && !this.hasFragileOption(this.getSelectedItem())) {
            this.setState({
                isFragile: false
            });
        }

        // hidden fields should always be in sync with the component state.
        $('#hfdShippingId').val(this.state.selectedShippingId);
        $('#hfdIsFragile').val(this.state.isFragile.toString());
        $('#hfdShippingInsurance').val(this.getSelectedItem() && this.getInsuranceDisplay(this.getSelectedItem())==="block"?this.state.shippingInsurance.toString():"true");

        // update order summary every time we change state
        var elementExists = document.getElementsByTagName("ordersummary");
        if (elementExists.length > 0) {
            OrderSummaryHelper.setDeliveryCost(this.getDeliveryCost(this.getSelectedItem()));   
        }
    }

    public render() {
        const itemsTemplate =
            this.state &&
            this.state.items &&
            this.state.items.map(address => this.getItemsTemplate(address));
        

        return (
            <div className="shipping" style={{ display: this.getComponentDiplay() }}>
                <h2 className="order-page__header">
                    شیوه ارسال
                </h2>

                <div className='shipping-alert' style={{ display: this.getShippingInfoDisplayStyle(this.state.items && this.state.items.length>0? this.state.items[0].expressType:0) }}>
                    <span>
                        {this.getExpressMessage(this.state.items && this.state.items.length > 0 ? this.state.items[0].expressType : 0)}
                    </span>
                </div>

                {itemsTemplate}
                
            </div>
        );
    }


    private checkShipping = () => {
        document.addEventListener('DOMContentLoaded', function () {
            var expressMessage = document.getElementsByClassName('shipping-alert')[0].getElementsByTagName('span');
            var ersalMessage = 'با توجه به اینکه کالاهای سبد خرید شما امکان «ارسال فوری» دارند، با انتخاب هر یک از گزینه های ارسال، در کمتر از 24 ساعت کاری کالا برای شما ارسال خواهد شد.';
            var shippingTitle = document.getElementsByClassName('shipping-title');
            if (expressMessage[0].innerHTML.includes(ersalMessage)) {
                for (var i = 0; i < shippingTitle.length; i++) {
                    if (shippingTitle[i].innerHTML.includes('تهران')) {
                        for (var j = 0; j < shippingTitle.length; j++) {
                            if (shippingTitle[j].innerHTML.includes('پست')) {
                                shippingTitle[j].parentElement.parentElement.parentElement.style.display = 'none';
                            }
                        }
                        break;
                    }
                }
            }

        })
    }

    private getExpressMessage = expressType =>
        expressType &&
        expressType === 0 ? '' :
        expressType === 1 ? 'با توجه به اینکه کالاهای سبد خرید شما امکان «ارسال فوری» دارند، با انتخاب هر یک از گزینه های ارسال، در کمتر از 24 ساعت کاری کالا برای شما ارسال خواهد شد.'
            :'با توجه به اینکه حداقل یکی از کالاهای سبد شما، دارای امکان «ارسال فوری» نیست، امکان ارسال فوری کمتر از 24 ساعت کاری برای شما وجود ندارد. در صورتی که تمایل دارید کالای مورد نظر به صورت فوری برایتان ارسال شود، به سبد خرید خود بازگشته و با حذف کالاهای ارسال فوری، آن ها را در سفارشی جدید ثبت نمایید.';

    private getShippingInfoDisplayStyle = expressType =>
        expressType &&
        expressType>0 ? 'block' : 'none';

    private getInitialState = (): State => ({
        items: null,
        selectedShippingId: Helpers.Utils.zeroIfEmpty($('#hfdShippingId').val().toString()),
        isOfficialInvoice: null,
        gstRate: null,
        isFragile: false,
        installmentEnabled: null,
        shippingInsurance: ($('#hfdShippingInsurance').val() as string).toLowerCase() === "true"
    });

    private getPriceText(item: ShippingItem) {
        const multiplier = this.state.isOfficialInvoice || this.state.installmentEnabled ? 1 : 0;
        const gstRate = multiplier * item.gstRate;
        if (item.price === 0) {
            if (item.priceText) {
                return Helpers.Utils.ConvertToPersianDigit(item.priceText);
            } else {
                return 'رایگان';
            }
        } else if (item.price < 0) {
            return 'وابسته به آدرس';
        } else {
            const deliveryCost = this.getDeliveryCost(item) * (1 + (gstRate * 0.01));
            return Helpers.Utils.formatPrice(Math.floor(deliveryCost));
        }
    }

    private reloadList = (addressId: number) => {
        if (!addressId) {
            this.setState({
                items: null
            });

            return;
        }

        var forceExUser = 0;
        var uid = 0;
        var hps = '';

        if ($('#hdfForceExUser').length > 0) {
            forceExUser = Helpers.Utils.zeroIfEmpty($('#hdfForceExUser').val().toString());
        }
        if ($('#hdfUId').length > 0) {
            uid = Helpers.Utils.zeroIfEmpty($('#hdfUId').val().toString());
        }
        if ($('#hdfHps').length > 0) {
            hps = $('#hdfHps').val().toString();
        }

        Helpers.LoadingHelper.showLoading();
        Helpers.ApiHelper.getShippingTypes(addressId, this.state.shippingInsurance, forceExUser, uid, hps).then(items => {
            this.setState({
                items
            });
        }).always(_ => {
            Helpers.LoadingHelper.hideLoading();
        });
    }

    private onSelect = id => e => {
        if (e.target.className.indexOf('js-no-click') >= 0) return;

        this.setState({
            selectedShippingId: id
        });
    }

    private addDefaultSrc(ev) {
        ev.target.src = '/src/broken-image.png';
    }

    private getItemsTemplate = (item: ShippingItem) =>
        <div key={item.id}
            className={`shipping-item ${item.id === this.state.selectedShippingId ? 'selected' : ''} ${item.expressType === 1 && item.title.includes('تهران') && item.title.includes('پست') ? 'no-shipping' : ''}`}
            onClick={this.onSelect(item.id)}>
            <div className='shipping-select-container'>
                <div className='shipping-select-circle'>
                    <i className='fa fa-check-square fa-lg shipping-select-icon' />
                </div>
            </div>

            <div className='shipping-image-container'>
                <img src={item.image} onError={this.addDefaultSrc} />
            </div>
            <div className="shipping-type-wrapper">
                <div className='shipping-text-container'>
                    <div className='shipping-title'>
                        {item.title}
                    </div>

                    <div className='shipping-description'>
                        {Helpers.Utils.ConvertToPersianDigit(item.description)}
                    </div>

                    <div style={{ display: this.getInsuranceDisplay(item) }}
                         className='insurance-container'>
                        <span onClick={this.toggleShippingInsurance} className='js-no-click'>
                            <i className={this.getInsuranceClassnames()}></i>
                            {this.getInsuranceText(item)}
                        </span>
                    </div>
                </div>

                <span className='shipping-price'>
                    {this.getPriceText(item)}
                </span>
            </div>
        </div>

    

    private getInsuranceDisplay = (item: ShippingItem) =>
        item.optionalInsurance && item.insuranceCost>item.baseInsurancePrice ? 'block' : 'none';
    private getComponentDiplay = () =>
        this.state.items && this.state.items.length > 0 ? 'block' : 'none'

    private getFragileClassnames = () =>
        this.state.isFragile ? 'check-box-check js-no-click' : 'check-box-not-check js-no-click'

    private getInsuranceClassnames = () =>
        this.state.shippingInsurance ? 'check-box-check js-no-click' : 'check-box-not-check js-no-click'

    private getInsuranceText = (item: ShippingItem) => {
        if (item.fullInsurance) {
            return "بیمه ارسال سفارش (سفارش به صورت کامل با مبلغ " +
                Helpers.Utils.ConvertToPersianDigit(Helpers.Utils.formatPrice(item.insuranceCost - item.baseInsurancePrice)) +
                " جهت ارسال بیمه می شود.)";
        } else {
            return "بیمه ارسال سفارش (مبلغ " +
                Helpers.Utils.ConvertToPersianDigit(Helpers.Utils.formatPrice(item.insuranceAmount)) +
                " از سفارش شما با مبلغ " +
                Helpers.Utils.ConvertToPersianDigit(Helpers.Utils.formatPrice(item.insuranceCost - item.baseInsurancePrice)) +
                " جهت ارسال بیمه می شود.)";
        }
    }

    private toggleFragile = () => {
        this.setState({
            isFragile: !this.state.isFragile
        });
    }

    private toggleShippingInsurance = () => {
        var newState = !this.state.shippingInsurance;
        this.setState({
            shippingInsurance: newState
        });
        if (!newState) {
            if ($("#insurance-modal").length>0) {
                $("#insurance-modal").show();
                $('.modal-overlay').show();
                $('#site-container').addClass('blur');
                $('body').css('overflow', 'hidden');
            }
        }
    }

    private getDeliveryCost = (item: ShippingItem): number => {
        if (!item) return null;

        var price = item.price - (!this.state.shippingInsurance && item.optionalInsurance && item.price > item.insuranceCost ? (item.insuranceCost - item.baseInsurancePrice) : 0);
        price = this.state.isFragile ?
            price * 1.25 :
            price;

        return price;
    }

    private setOfficialInvoice = (value: boolean) => {
        this.setState({
            isOfficialInvoice: value
        });
    }

    private setInstallmentState = (value: boolean) => {
        this.setState({
            installmentEnabled: value
        });
    }

    private getSelectedItem = () => this.state.items ?
        this.state.items.find(x => x.id === this.state.selectedShippingId) :
        null

    private hasFragileOption = (item: ShippingItem) =>
        item && item.title.indexOf('پست') >= 0
}

Helpers.ReactHelper.createReactElement('ShippingList', ShippingList);

export default shippingListHelper;
